import { ProductPurchasability } from "../public-purchasable/publicpurchasable";
import { fetchPublicPurchasableData } from "../public-purchasable/fetchPublicPurchasable";
import { extractProductTilesToFetchPrices } from "./../product-pricing/priceUtils";


export const initProductTile = async (win) => {

    const products = [...win.document.querySelectorAll(`.product-tile`)];
    const productCodesWithShowPrice : string[] = extractProductTilesToFetchPrices(win).map(el => el.dataset.productCode);
    const productIds:number[] = productCodesWithShowPrice.map(productCode => parseInt(productCode));
    const productPurchasabilityMap: Map<number,ProductPurchasability> = await fetchPublicPurchasableData(productIds);

    let isNz = false;
    let isMax = false;

    if (window.location.host.indexOf('.co.nz') > -1) {
        isNz = true;
    }
    products.forEach((product: HTMLElement) => {
        const code = parseInt(product.getAttribute('data-product-code'));
        let productPurchsability = productPurchasabilityMap.get(code);
        isMax = (window.document.querySelector("[data-user-type='MAX_USER']") && true) || (productPurchsability === "MAX_ONLY");
        const labelText = product.getElementsByClassName('trade-only-prompt')[0];

        if(isNz && isMax) {
            if(labelText) {
                labelText.innerHTML = "Available online to trade account holders in maX";
                labelText.innerText = "Available online to trade account holders in maX";
            }
        }
    })
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/product-tile/productTile.js